<template>
  <div class="landing">
    <div class="container">
      <div class="row mt-md-4 mt-3">
        <div class="col">
          <a
            href="https://lemanapro.ru/"
            class="logo_main"
          />
        </div>

        <div class="col text-right align-self-center">
          <a
            id="login"
            href
            class="btn"
            @click.stop.prevent="login"
          >Войти</a>
        </div>
      </div>
    </div>

    <div class="container pt-md-5 pb-md-5 pb-4">
      <div class="row">
        <div class="col-12 col-lg-55 pt-45">
          <h1>
            Зарабатывайте вместе
            <br>с Лемана ПРО
          </h1>
          <p class="pt-3 pb-2 info info">
            До 6.5% с каждой покупки
            <br class="d-sm-block d-md-none">по партнёрской программе
          </p>
          <a
            href="#reg"
            class="btn green_btn btn-lg pr-5 pl-5 mt-md-1"
            @click="becomePartner"
          >Стать партнёром</a>
        </div>
        <div class="col-12 col-lg-65 mt-5 mt-sm-0 order-first order-md-last">
          <img
            src="../assets/images/main.svg"
            height="351"
            class="mt-md-2 img-fluid"
            alt="Лемана ПРО"
          >
        </div>
      </div>
    </div>

    <div class="shad">
      <div class="container mt-md-4 pt-5 mt-3">
        <div class="row">
          <div class="col-12 col-md-6">
            <h2 class="pt-md-2">
              Как заработать
              <br class="d-sm-block d-md-none">на партнёрской программе Лемана ПРО
            </h2>
          </div>
        </div>
      </div>
    </div>

    <div class="container pt-md-5 pb-md-5 mt-4 mt-md-2">
      <div class="row way">
        <div class="col-12 col-md-4 mb-5">
          <div class="item item_1">
            <div class="green_block p-3">
              <div class="border-white pt-3 p-2">
                <a
                  href="#reg"
                  class="underline"
                  @click="fillForm"
                >Заполните заявку</a>
                <br>на сайте
              </div>
            </div>
            <div id="people1" />
          </div>
        </div>

        <div class="col-12 col-md-4 mb-5">
          <div class="item item_2">
            <div
              id="people21"
              class="d-none d-md-block"
            />
            <div class="green_block p-3">
              <div class="border-white pt-lg-3 p-2">
                Рассказывайте
                <br class="lg">о нас <br class="sm">и размещайте партнёрские <br class="sm">ссылки на своих
                площадках
              </div>
            </div>
            <div id="people2" />
          </div>
        </div>

        <div class="col-12 col-md-4">
          <div class="item item_3 mr-md-3">
            <div class="green_block p-3">
              <div id="icon" />
              <div class="border-white pt-3 p-2">
                Получайте комиссию
                <br>с продажи до 6,5%
              </div>
              <div id="people3" />
            </div>
          </div>
        </div>
      </div>
      <landing-commission />
    </div>

    <div class="container">
      <bonus-scale />
    </div>

    <div class="bg shad">
      <div class="container mt-5 pt-5 pb-5 mb-md-5 mt-0--on-mobile">
        <div class="row">
          <div class="col-12 col-md-3 d-none d-md-block pt-md-4">
            <img
              src="../assets/images/bg.svg"
              height="250"
              alt="Лемана ПРО"
              class="image"
            >
          </div>
          <div class="col-12 col-md-9 pl-md-5">
            <div class="row">
              <div class="col-12 mb-3 pl-md-4">
                <h2>С нами зарабатывают</h2>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-md-4 mt-3 pl-md-4">
                <div class="indicator mb-md-2">
                  <h2 class="b">
                    500 354
                    <span class="rub">руб.</span>
                  </h2>
                </div>
                <p class="pr-md-3">
                  заработал наш партнёр
                  <br class="d-sm-block d-md-none">за прошлый месяц
                </p>
              </div>
              <div class="col-12 col-md-4 mt-3 pl-md-4">
                <div class="indicator mb-md-2">
                  <h2 class="b">
                    до 9 млн
                  </h2>
                </div>
                <p class="pr-md-3">
                  посетителей на сайте
                  <br class="d-sm-block d-md-none">за прошлый месяц
                </p>
              </div>
              <div class="col-12 col-md-4 mt-3 pl-md-4">
                <div class="indicator mb-md-2">
                  <h2 class="b">
                    до 6,5%
                  </h2>
                </div>
                <p class="pr-md-4">
                  вы можете заработать
                  <br class="d-sm-block d-md-none">с нами
                </p>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-md-6 mt-4 text-center text-md-left pl-md-4">
                <a
                  id="with_us"
                  href="#reg"
                  class="btn green_btn btn-lg"
                  @click="startEarning"
                >Начать зарабатывать</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container mt-5 pb-5">
      <div class="row">
        <div class="col-md-6 col-12">
          <h2>
            Заполните заявку
            <br class="d-sm-block d-md-none">и начните зарабатывать <br class="d-sm-block d-md-none">с нами
          </h2>
        </div>
      </div>
      <div class="row">
        <a name="reg" />
        <div class="col-12 col-lg-7 col-xl-6">
          <registration-form />
        </div>
        <div class="col-12 col-lg-5 col-xl-6 text-center text-md-right p-5 p-md-0 d-none d-lg-block">
          <img
            src="../assets/images/form.svg"
            height="362"
            class="reg_image"
            alt="Леруа Мерлен"
          >
        </div>
      </div>
    </div>

    <footer class="mt-md-3">
      <div class="container pt-4 pb-4">
        <div class="bottom-row">
          <div class="col-12 col-sm-5 col-md-1 align-self-center">
            <a
              href="https://lemanapro.ru/"
              class="logo_main"
            />
          </div>
          <div class="col-12 col-md-2 align-self-center text-md-center mt-2 mt-md-0">
            <a href="https://lemanapro.ru/">lemanapro.ru</a>
          </div>
          <div class="col-12 col-md-9 align-self-center text-md-right">
            <a
              href="https://partners.lemanapro.ru/page/contacts"
              target="_blank"
              class="mt-2 mt-md-0 mr-md-5 d-block d-md-inline"
            >Контакты</a>
            <a
              href="https://partners.lemanapro.ru/page/pravila-partnerskoy-programmy"
              target="_blank"
              class="mt-2 mt-md-0 d-block d-md-inline"
            >Правила партнёрской программы</a>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>
<script>
import LandingCommission from '@/components/landing/LandingCommission.vue';
import BonusScale from '@/components/landing/BonusScale.vue';
import RegistrationForm from '../components/auth/RegistrationForm.vue';

export default {
  name: 'Landing',
  components: {
    LandingCommission,
    BonusScale,
    RegistrationForm,
  },
  methods: {
    login() {
      window.open('https://partners.lemanapro.ru/auth/', '_self');

      window.dataLayer.push({
        event: 'LeroyMerlin',
        eventCategory: 'Interactions',
        eventAction: 'click',
        eventLabel: 'button',
        eventLocation: 'Landing',
        eventContent: 'Войти',
        eventContext: 'С нами зарабатывают',
      });
    },
    becomePartner() {
      window.dataLayer.push({
        event: 'LeroyMerlin',
        eventCategory: 'Interactions',
        eventAction: 'click',
        eventLabel: 'button',
        eventLocation: 'Landing',
        eventContent: 'Стать партнёром',
        eventContext: 'Зарабатывайте вместе с Лемана ПРО',
      });
    },
    fillForm() {
      window.dataLayer.push({
        event: 'LeroyMerlin',
        eventCategory: 'Interactions',
        eventAction: 'click',
        eventLabel: 'button',
        eventLocation: 'Landing',
        eventContent: 'Заполните заявку',
        eventContext: 'Как заработать на партнёрской программе Лемана ПРО',
      });
    },
    startEarning() {
      window.dataLayer.push({
        event: 'LeroyMerlin',
        eventCategory: 'Interactions',
        eventAction: 'click',
        eventLabel: 'button',
        eventLocation: 'Landing',
        eventContent: 'Начать зарабатывать',
        eventContext: 'С нами зарабатывают',
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import url('../assets/css/custom.css');
.mt-0--on-mobile {
  @media (max-width: 576px) {
    margin-top: 0 !important;
  }
}
.image {
  width: 100%;
}
.bottom-row {
  display: flex;
  margin-right: -10px;
  margin-left: -10px;
}
</style>
